















import { Component, Vue, Prop } from 'vue-property-decorator';

import QuestionTitle from './question-title.vue';
import { Question } from '@/domains/template';

@Component({
  name: 'MultiCheckbox',
  components: {
    'question-title': QuestionTitle,
  },
})
export default class MultiCheckbox extends Vue {
  private answer: string[] = [];
  @Prop()
  private value: Question;

  @Prop({ default: false })
  private save: boolean;

  constructor() {
    super();
    if (this.question.answer === null || this.question.answer.answer === null) {
      this.answer = [];
    } else {
      this.answer = this.question.answer.answer.split(',');
    }
  }

  get question(): Question {
    return this.value;
  }

  set question(value: Question) {
    this.$emit('input', value);
  }

  private change(value: string[]): void {
    this.question.answer.answer = value.join(',');
  }
}
